<template>
    <div id="box_newsletter" class="vue timparty-newsletter-box newsletter-box bg-dark text-white text-center p-4" v-if="user.fe_id" moveY="-200">


        <!-- NOT SUBSCRIBED / START -->
        <div v-if="!isSubscribed">
          <h3 class="font-weight-bold text-uppercase">{{ txt.not_subscribed_title }}</h3>

          <div class="mt-5 mx-4">
            {{ txt.not_subscribed_intro_1 }}<br>
            {{ txt.not_subscribed_intro_2 }}
          </div>

          <div class="form-newsletter mt-5">

            <div class="form">

                <div :class="'form-group '">
                    <label for="">{{ __('Inserisci la tua email*') }}</label>
                    <input type="text" :class="'form-control '  + (validation_errors.email ? 'border-danger' : '')" v-model="email">
                </div>
                <div class="row no-gutters">
                    <div class="col-8 col-md-9 text-left">




                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="privacy-acceptance-not-subscribed" v-model="privacy_acceptance">
                            <label :class="'custom-control-label ' + (validation_errors.privacy_acceptance ? 'text-danger' : '')"  for="privacy-acceptance-not-subscribed"><small>{{ txt.privacy_label }}</small>
                              <span v-if="!hideInfo">
                                <a v-if="user" :href="user.news_privacy_policy_url" target="_blank" class="icon-privacy-info ml-1" ><img :src="modulePath('js/src/assets/images/icon-white-info-square.png')"></a>
                                <a v-else href="#" class="icon-privacy-info ml-1" @click.prevent="modal.show = true"><img :src="modulePath('js/src/assets/images/icon-white-info-square.png')"></a>
                              </span>
                            </label>
                          </div>

                    </div>
                    <div class="col-4 col-md-3">
                        <!--<button class="btn btn-primary btn-block" :disabled="!formValid" @click.prevent="submitForm(true)">{{ __('Invia') }}</button>-->
                        <button class="btn btn-primary btn-block" @click.prevent="submitForm(true)">{{ __('Invia') }}</button>
                    </div>
                </div>
            </div>

            <div v-if="alert.message" class="my-3" :class="alert.class_name" v-html="alert.message" :role="alert.role"></div>

            <div class="mt-5">
              <small>{{ txt.mandatory_fields_label}}</small>
            </div>

          </div>
        </div>
        <!-- NOT SUBSCRIBED / END -->


        <!-- ALREADY SUBSCRIBED / START -->
        <div v-else>
          <h3 class="font-weight-bold text-uppercase">{{ txt.subscribed_title }}</h3>

          <div class="mt-5 mx-4">

            {{ txt.subscribed_intro_1 }}<br>
            {{ txt.subscribed_intro_2 }}
          </div>

          <div class="form-newsletter mt-5">

            <div class="form">

                <div class="form-group">
                    <label for="">{{ txt.email_label }}</label>
                    <input type="text" disabled class="form-control" v-model="user.contact_email">


                </div>


                <div class="mt-5" v-if="enableEdit">
                  <button v-if="!show_edit_form" class="btn btn-primary"  @click="show_edit_form = true">{{ txt.edit_form_button }}</button>
                </div>
                <div class="mt-5" v-else>
                  <a :href="profileUrl" class="btn btn-primary">{{ __('Vai alla sezione profilo') }}</a>
                </div>



                <div v-if="show_edit_form">

                  <small>{{ txt.edit_form_intro }}</small>
                  <div :class="'form-group mt-3 ' ">
                      <label for="">{{ txt.new_email_label }}</label>
                      <input type="text" :class="'form-control '  + (validation_errors.email ? 'border-danger' : '')" v-model="email">
                  </div>

                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="privacy-acceptance-subscribed" v-model="privacy_acceptance">
                      <label :class="'custom-control-label ' + (validation_errors.privacy_acceptance ? 'text-danger' : '')" for="privacy-acceptance-subscribed"><small>{{ txt.privacy_label }}</small>
                        <span v-if="!hideInfo">
                          <a v-if="user" :href="user.news_privacy_policy_url" target="_blank" class="icon-privacy-info ml-3" ><img :src="modulePath('js/src/assets/images/icon-white-info-square.png')"></a>
                          <a v-else href="#" class="icon-privacy-info ml-3" @click.prevent="modal.show = true"><img :src="modulePath('js/src/assets/images/icon-white-info-square.png')"></a>
                        </span>
                      </label>
                    </div>

                  <div class="mt-4">
                    <button class="btn btn-primary" @click.prevent="submitForm()">{{ __('Modifica') }}</button>
                  </div>


                   <div v-if="alert.message" class="mt-3" :class="alert.class_name" v-html="alert.message" :role="alert.role"></div>

                  <div class="mt-5">
                    <small>{{ txt.mandatory_fields_label}}</small>
                  </div>

                </div>

            </div>



          </div>
        </div>
        <!-- ALREADY SUBSCRIBED / END -->






        <!-- PRIVACY POLICY / START -->
        <basic-modal :modal-id="modal_id" modal-class="modal-sm" class="modal-acceptance" :show="modal.show" v-on:modalClose="modal.show = false">

              <div class="modal-body p-5">
                <ContentPrivacyPolicy/>
              </div>

        </basic-modal>
        <!-- PRIVACY POLICY / END -->



        <!-- MODAL ERROR / BEGIN -->
        <ErrorModal :error="error" v-on:modalClose="error = null"/>
        <!-- MODAL ERROR / END -->


    </div>
</template>

<script>

    /* eslint-disable */

    import TimPartyMixin from '../mixins/TimPartyMixin';
    import BasicModal from './BasicModal.vue'
    import ErrorModal from './ErrorModal.vue'
    import ContentPrivacyPolicy from './ContentPrivacyPolicy.vue'

    export default {
      name: 'NewsletterBox',
      mixins: [ TimPartyMixin ],
      components: { BasicModal, ContentPrivacyPolicy, ErrorModal },
      props: {
        apiUrl: {
          type: String,
          default: '/api/user/handleAction',
        },
        enableEdit: {
          type: Boolean,
          default: false,
        },
        profileUrl: {
          type: String,
          default: '/profilo',
        },
        texts: {
          type:Object,
          default: {},
        },

      },
      data: function(){

        return {
          email: '',
          privacy_acceptance: false,

          validation_message: '',
          validation_errors: {},

          alert: {
            class_name: '',
            message: '',
            role: '',
          },

          show_edit_form: false,


           modal: {
              id: 'modal-newsletter',
              show: false,
              class_name: 'modal-sm',
              error: null,
              state: null,
          },

          txt: {
            email_label: 'Email di iscrizione',
            new_email_label: 'Nuova email di iscrizione*',
            privacy_label: 'Ho preso visione dell\'Informativa Privacy*',

            not_subscribed_title: 'Iscriviti alla newsletter',
            not_subscribed_intro_1:'Iscriviti alla Newsletter per rimanere sempre aggiornato sulle nuove iniziative, i concorsi attivi e i vantaggi a te dedicati.',
            not_subscribed_intro_2: 'Inserisci l\'indirizzo email, prendi visione dell\'Informativa Privacy e procedi con l\'iscrizione!',

            subscribed_title: 'Sei iscritto alla newsletter',
            subscribed_intro_1: 'Sarai sempre aggiornato sulle nuove iniziative, i concorsi attivi e i vantaggi a te dedicati.',
            subscribed_intro_2: 'Di seguito trovi la mail con la quale ti sei iscritto alla Newsletter, puoi sempre modificarla dalla sezione Profilo!',

            edit_form_button: 'Modifica iscrizione',
            edit_form_intro: 'Se vuoi modificare l\'indirizzo email di iscrizione alla newsletter, inserisci il nuovo indirizzo nel box sotto, e prendi visione dell\'informativa privacy',

            form_validation_error_title: 'Errore nella compilazione del modulo',
            form_validation_error_summary: 'Si prega di verificare i campi indicati',
            form_validation_privacy_error: 'È necessario prendere visione dell\'Informativa Privacy',
            form_validation_email_error: 'Email non valida',

            result_message_success_new: 'La tua iscrizione alla Newsletter è avvenuta con successo!',
            result_message_success_edit: 'La modifica alla tua iscrizione alla Newsletter è avvenuta con successo.',
            result_message_error:'Errore nel salvataggio dei dati',

            mandatory_fields_label: '*Campi obbligatori',




            // legacy

            phone_label: 'Inserisci contatto telefonico',
            form_title: 'I tuoi dati',

            message_save_success: 'Abbiamo salvato correttamente il tuo telefono di contatto',
            message_save_error: 'Errore nel salvataggio dei dati'
         },

        };
      },
      mounted: function(){

        this.setApiUrl(this.apiUrl);
        this.txt = { ...this.txt, ...this.texts}
      },

      methods: {
        validateForm: function(){

          this.email = this.email.trim();
          this.validation_message = '';

          var result = this.checkEmail( this.email ) && this.privacy_acceptance;

          if( !this.checkEmail( this.email ) ){
            this.validation_message = '&bull; ' + this.txt.form_validation_email_error + '<br>';
            this.validation_errors['email'] = true;
          }
          else{
            this.validation_errors['email'] = false;
          }

          if( !this.privacy_acceptance ){
              this.validation_message += '&bull; ' + this.txt.form_validation_privacy_error + '<br>';
              this.validation_errors['privacy_acceptance'] = true;
          }
          else{
            this.validation_errors['privacy_acceptance'] = false;
          }

          return result;
        },


        submitForm: function(is_new){

          if(!this.validateForm()){

            this.modal.show = false;
            this.showError(this.txt.form_validation_error_title, this.validation_message);// this.txt.form_validation_error_summary);
            return;
          }

          this.aaEvent('click', {
                          form: {
                              click: "Invia newsletter",
                              }
                          });


          var self = this;

          var payload = {
            action: 'subscribeToNewsletter',
            access_token: this.access_token,
            data : {
              email: this.email,
            }
          };


          this.loading = true;
          this.callApi( payload, function( response){
            console.log(response);

            self.loading = false;

            if( response.success ){

              self.alert.class_name = 'text-accent strong';
              self.alert.message = is_new ? self.txt.result_message_success_new : self.txt.result_message_success_edit;
              self.alert.role = 'success';
            }
            else{
              self.alert.class_name = 'text-danger';
              self.alert.message = self.txt.result_message_error;
              self.alert.role = 'failure';
            }

          } );
        }



      },
      computed: {
        formValid: function(){
          return ( this.privacy_acceptance && this.checkEmail( this.email ) );
        },
        isSubscribed: function(){
          return this.user.flg_privacy_mail;
        }
      }
    }
  </script>
